import React, {Fragment} from 'react';
import {Flex, Card, Clarity, Slider, Form, Textarea, List} from 'components';
import {config, map, useNamedSelector, noop} from 'helpers';

export function RealityCheckContinue() {
  const values = useNamedSelector('clarity.realityCheck');
  return (
    <Fragment>
      <p>You can now clearly see where your life is strong and solid, and where you are missing something or there is a lack of balance. Appreciate the areas, situations, and people in your life that cause you joy and satisfaction, and decide to work on the areas that you are not completely happy with. The { config.appName } program will guide and support you through this process.</p>
      <p>Look at your Life Chart and consider the following questions:</p>
      <Flex large-gutter className="medium-spacing" stack>
        <div data-stretch>
          <b>My Life Chart</b>
          <Card className="tiny-spacing" medium>
            <List>
              { map(Clarity.RealityCheck.fields, ( label, name ) =>
                <div key={name}>
                  <Flex justified>
                    <b>{ label }</b>
                    <Clarity.RealityCheck.Label name={name} />
                  </Flex>
                  <Slider min={1} max={10} filled="colored" value={values[name]} setValue={noop} disabled />
                </div>
              ) }
            </List>
          </Card>
        </div>
        <div data-stretch>
          <Form {...useNamedSelector('clarity.form', { name: 'reality-check-continue' })}>
            <List tiny-gutter>
              <List.Title bold>What part of myself am I ignoring or neglecting?</List.Title>
              <Textarea single name="1" />
              <List.Title bold>Which parts of my life really work? Which don't?</List.Title>
              <Textarea single name="2" />
              <List.Title bold>What am I longing for in my life? What am I fundamentally missing?</List.Title>
              <Textarea single name="3" />
            </List>
          </Form>
        </div>
      </Flex>
      <p className="medium-spacing">Now after you reviewed the different aspects of your life and identified those areas that are not creating the level of happiness and satisfaction you are looking for, you are ready to dig deeper into any of these areas and ask yourself a few key questions to get a better sense for where you are and where you want to be.</p>
      <p>The following sections of Clarity Wizard include specific and targeted inquiries in eight different parts of your life. Choose an area of your life where you would like to see change and then begin to set specific goals and consider possible action. We recommend that you initially focus on only one or two areas.</p>
    </Fragment>
  );
}
